export const VarianceGroupByValues = ['team', 'plan', 'itemType', 'integration'] as const;
export type VarianceGroupBy = (typeof VarianceGroupByValues)[number];

export interface VarianceStats {
  totalActualSeconds: number;
  totalPlanSeconds: number;
  percentageDiff: number | null;
  itemCount: number;
}

export interface VarianceGroup {
  groupKey: number;
  totalActualSeconds: number;
  totalPlanSeconds: number;
  percentageDiff: number | null;
  itemCount: number;
}

export interface VarianceBreakdown {
  groups: VarianceGroup[];
  ungrouped: VarianceStats | null;
  totals: VarianceStats;
}
